/* tslint:disable */
/* eslint-disable */
/**
 * Melco Efs APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface EfsMelcoEfsModelsSchemaListItem
 */
export interface EfsMelcoEfsModelsSchemaListItem {
    /**
     * 
     * @type {string}
     * @memberof EfsMelcoEfsModelsSchemaListItem
     */
    id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EfsMelcoEfsModelsSchemaListItem
     */
    display_name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EfsMelcoEfsModelsSchemaListItem
     */
    value?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof EfsMelcoEfsModelsSchemaListItem
     */
    show?: boolean;
}

export function EfsMelcoEfsModelsSchemaListItemFromJSON(json: any): EfsMelcoEfsModelsSchemaListItem {
    return EfsMelcoEfsModelsSchemaListItemFromJSONTyped(json, false);
}

export function EfsMelcoEfsModelsSchemaListItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): EfsMelcoEfsModelsSchemaListItem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'display_name': !exists(json, 'display_name') ? undefined : json['display_name'],
        'value': !exists(json, 'value') ? undefined : json['value'],
        'show': !exists(json, 'show') ? undefined : json['show'],
    };
}

export function EfsMelcoEfsModelsSchemaListItemToJSON(value?: EfsMelcoEfsModelsSchemaListItem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'display_name': value.display_name,
        'value': value.value,
        'show': value.show,
    };
}


